<template>
  <div>
    <a-card
      size="small"
      title="查询"
      :headStyle="{
        background: '#f3f3f3',
      }"
    >
      <a-form layout="inline">
        <a-form-item>
          <!-- <a-input placeholder="商户筛选" v-model="searchForm.name" allowClear @keyup.enter.native="searchAction()"/> -->

          <df-selectChannelShop
            @setValue="searchAction()"
            :model="searchForm"
          ></df-selectChannelShop>

        </a-form-item>


        <!-- 获取供应商信息 -->
        <a-form-item>
          <df-selectSupplierShop
              :model="searchForm"
              @setValue="searchAction"
              style="width: 220px"
          ></df-selectSupplierShop>
        </a-form-item>



        <a-form-item>
          <a-range-picker
            v-model:value="searchForm.date"
            :placeholder="['创建开始', '创建结束']"
            valueFormat="YYYY-MM-DD"
            format="YYYY-MM-DD"
          />
        </a-form-item>

        <a-form-item>
          <a-input
              placeholder="订单号"
              v-model:value="searchForm.orderCode"
              allowClear
              @keyup.enter.native="searchAction()"
          />
        </a-form-item>

        <a-form-item>
          <a-button type="primary" @click="searchAction"> 查询 </a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="reset">重置</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="downloadAction"> 下载 </a-button>
        </a-form-item>
      </a-form>
    </a-card>
    <div class="card_ct">
      <a-card style="width: 280px; margin-top: 20px">
        <a-statistic
          :title="cardttitle + '账户资金'"
          :value="moneyTotle.total"
          :precision="2"
          class="demo-class"
          :value-style="{ color: '#cf1322' }"
        >
          <template #prefix>
            <my-icon type="iconziyuanldpi" style="margin-right: 10px" />
          </template>
        </a-statistic>
      </a-card>

      <a-card style="width: 280px; margin-top: 20px">
        <a-statistic
          title="当月充值"
          :value="moneyTotle.currentMonthRecharge"
          :precision="2"
          class="demo-class"
          :value-style="{ color: '#75f454' }"
        >
          <template #prefix>
            <my-icon type="iconchongzhi" style="margin-right: 10px" />
          </template>
        </a-statistic>
      </a-card>

      <a-card style="width: 280px; margin-top: 20px">
        <a-statistic
          title="当月使用资金"
          :value="moneyTotle.currentMonthUse"
          :precision="2"
          class="demo-class"
          :value-style="{ color: '#4196d5' }"
        >
          <template #prefix>
            <my-icon type="iconzijin" style="margin-right: 10px" />
          </template>
        </a-statistic>
      </a-card>
    </div>
    <a-card
      size="small"
      title="资金列表"
      style="margin-top: 20px"
      :headStyle="{
        background: '#f3f3f3',
      }"
      :bodyStyle="{
        padding: '0',
      }"
    >
      <template v-slot:extra>
        <a-button slot="extra" @click="toAdd" type="primary">充值</a-button>
      </template>
      <a-table
        :columns="columns"
        style="overflow: auto"
        bordered
        :data-source="list"
        :pagination="false"
        :row-key="(r) => r.id"
        :loading="loading"
      >
        <template v-slot:creater="{ text, record }">
          {{ record.creatorBo.username }}
        </template>

        <template v-slot:changeTypeValue="{ text, record }">
          <span
            v-if="
              record.changeType == 30 ||
              record.changeType == 40 ||
              record.changeType == 31 ||
              record.changeType == 41 ||
              record.changeType == 43
            "
            style="color: #464c5b;"
            >{{ record.changeTypeValue }}</span
          >
          <span v-else>{{ record.changeTypeValue }}</span>
        </template>

        <template v-slot:operation="{ text, record }">
          <a-button
            type="primary"
            @click="toLook(record)"
            v-if="record.changeType == 10 || record.changeType == 60"
          >
            查看详情
          </a-button>
        </template>

        <template v-slot:shop="{ text, record }">
          <span
            style="color: #464c5b; cursor: pointer"
            @click="toShopDetail(record)"
            >{{ record.distributorBo.name }}</span
          >
        </template>
      </a-table>
    </a-card>
    <a-modal
      title="充值信息"
      style="top: 20px"
      v-model:visible="modalVisible"
      :footer="null"
      :width="1100"
    >
      <div class="modal_ct">
        <div>
          <a-row :gutter="24" class="ar">
            <a-col :span="8" class="bgl"> 系统流水号： </a-col>
            <a-col :span="16" class="bgr">
              {{ orderDetail.flowCode }}
            </a-col>
          </a-row>
          <a-row :gutter="24" class="ar">
            <a-col :span="8" class="bgl"> 平台流水： </a-col>
            <a-col :span="16" class="bgr">
              {{ orderDetail.paymentCode }}
            </a-col>
          </a-row>
          <a-row :gutter="24" class="ar">
            <a-col :span="8" class="bgl"> 充值金额： </a-col>
            <a-col :span="16" class="bgr">
              {{ orderDetail.amount }}（元）
            </a-col>
          </a-row>

          <a-row :gutter="24" class="ar">
            <a-col :span="8" class="bgl"> 充值日期： </a-col>
            <a-col :span="16" class="bgr">
              {{ orderDetail.createTime }}
            </a-col>
          </a-row>
        </div>
        <div>
          <a-row :gutter="24" class="ar">
            <a-col :span="8" class="bgl"> 充值商户： </a-col>
            <a-col :span="16" class="bgr">
              {{ orderDetail.distributorName }}
            </a-col>
          </a-row>

          <a-row :gutter="24" class="ar">
            <a-col :span="8" class="bgl"> 充值平台： </a-col>
            <a-col :span="16" class="bgr">
              {{ orderDetail.paymentTypeValue }}
            </a-col>
          </a-row>
          <a-row :gutter="24" class="ar">
            <a-col :span="8" class="bgl"> 充值业务： </a-col>
            <a-col :span="16" class="bgr">
              {{ orderDetail.businessValue }}
            </a-col>
          </a-row>
          <a-row :gutter="24" class="ar">
            <a-col :span="8" class="bgl"> 充值备注： </a-col>
            <a-col :span="16" class="bgr">
              {{ orderDetail.remarks }}
            </a-col>
          </a-row>
        </div>
      </div>
      <df-titleline :title="'充值凭证'"></df-titleline>
      <a-row>
        <!-- <viewer :images="fileList1"> -->
        <img
          v-for="(src, index) in orderDetail.paymentVoucher.split(',')"
          :src="baseuri + src"
          :key="index"
          class="viewer_img"
          @click="preview(src)"
        />
        <!-- </viewer> -->
      </a-row>
    </a-modal>

    <df-pagination :model="pageObj"></df-pagination>

    <a-modal v-model:visible="viewVisible" title="预览" width="800">
      <!-- @ok="handleOk" -->
      <img :src="baseuri + prevImg" style="width: 100%" />
    </a-modal>
  </div>
</template>

<script>
import shopApi from "@axios/shop";
import { ref, provide } from "vue";
import { useRouter } from "vue-router";
import moneyApi from "@axios/money";
import excelApi from "@axios/downloadExcel";
import tools from "@/utils/tools";
import { message } from "ant-design-vue";

export default {
  name: "shop",
  setup() {
    const router = useRouter();

    let modalVisible = ref(false);
    let loading = ref(false);
    let searchForm = ref({
      distributorId: undefined,
      date: [],
      orderCode: undefined,
      supplierId: undefined
    });
    let searchParams = ref({
      distributorId: undefined,
      date: [],
      orderCode: undefined
    });

    const stateList = [
      {
        name: "供应",
        val: 10,
      },
      {
        name: "渠道",
        val: 20,
      },
    ];

    let list = ref([]);

    const columns = [
      {
        title: "渠道商户",
        dataIndex: "flowCode",
        width: 100,
        align: "center",
        slots: { customRender: "shop" },
      },
      {
        title: "供应商户",
        dataIndex: "supplierName",
        width: 100,
        align: "center"
      },

      {
        title: "订单号",
        dataIndex: "orderCode",
        width: 200,
        align: "center",
      },
      {
        title: "系统流水号",
        dataIndex: "flowCode",
        width: 200,
        align: "center",
      },
      {
        title: "支付平台流水号",
        dataIndex: "paymentCode",
        width: 200,
        align: "center",
      },
      {
        title: "充值人",
        dataIndex: "taxpayerNum",
        width: 100,
        align: "center",
        slots: { customRender: "creater" },
      },
      {
        title: "变动前余额",
        dataIndex: "beforeBalance",
        width: 150,
        align: "center",
        slots: { customRender: "beforeBalance" },
      },
      {
        title: "变动金额（元）",
        dataIndex: "amount",
        width: 120,
        align: "center",
      },
      {
        title: "变动后余额",
        dataIndex: "afterBalance",
        width: 150,
        align: "center",
        slots: { customRender: "afterBalance" },
      },
      {
        title: "创建时间",
        dataIndex: "createTime",
        width: 150,
        align: "center",
      },
      {
        title: "变动类型",
        dataIndex: "changeTypeValue",
        width: 150,
        align: "center",
        slots: { customRender: "changeTypeValue" },
      },
      {
        title: "业务",
        dataIndex: "businessValue",
        width: 100,
        align: "center",
      },
      {
        title: "操作",
        align: "center",
        dataIndex: "operation",
        key: "operation",
        width: 100,
        slots: { customRender: "operation" },
      },
    ];

    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1,
    });

    const pageChange = (page) => {
      pageObj.value.page = page;
      getList();
    };

    const onShowSizeChange = (current, pageSize) => {
      pageObj.value.page = 1;
      pageObj.value.rows = pageSize;
      getList();
    };

    const searchAction = () => {
      searchParams.value.distributorId = searchForm.value.distributorId;
      searchParams.value.date = searchForm.value.date;
      searchParams.value.orderCode = searchForm.value.orderCode;
      searchParams.value.supplierId = searchForm.value.supplierId;

      pageObj.value = {
        page: 1,
        rows: 10,
        totle: 1,
      };
      getList();
    };

    const downloadAction = () => {
      searchParams.value.distributorId = searchForm.value.distributorId;
      searchParams.value.date = searchForm.value.date;
      searchParams.value.orderCode = searchForm.value.orderCode;
      searchParams.value.supplierId = searchForm.value.supplierId;
      getAllToExcel();
    };

    const getAllToExcel= () => {
      loading.value = true;
      let params = {
        distributorId: searchParams.value.distributorId,
        orderCode: searchParams.value.orderCode,
        supplierId: searchParams.value.supplierId
      };

      if (searchParams.value.date.length) {
        params.startTime = searchParams.value.date[0];
        params.endTime = searchParams.value.date[1];
      }

      if (params.startTime === undefined || params.startTime === '' || params.endTime === undefined || params.endTime === ''){
        message.error("请选择时间区间！");
        loading.value = false;
        return
      }
      if (!tools.isWithinMaxDay(params.startTime,params.endTime, 366)){
        message.error("下载时间区间，不能大于一年！");
        loading.value = false;
        return
      }

      excelApi.distributorExcel(params).then((res) => {
        loading.value = false;
        let blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"}); // 为blob设置文件类型，这里以.xlsx为例
        let url = window.URL.createObjectURL(blob); // 创建一个临时的url指向blob对象
        let a = document.createElement("a");
        a.href = url;
        a.download = '渠道流水'+tools.getNowDate();
        a.click();
        // 释放这个临时的对象url
        window.URL.revokeObjectURL(url);

        getList();
      }).catch((err) => {});


    };

/*    const download = (data) => {
      if (!data) {
        return
      }
      let url = window.URL.createObjectURL(new Blob([data]))
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', 'excel.xlsx')

      document.body.appendChild(link)
      link.click()
    }*/

    /**
     * 下载excel
     * @param  data  接口返回数据 res.data
     * @param res 接口返回数据 res
     * @returns excel文件
     */
    function exportExcel(data, res) {
      if (!data) {
        // 如果没有data数据就不进行操作
        return;
      }

      // 获取headers中的filename文件名
      const tempName = res.headers["content-disposition"]
          .split(";")[1]
          .split("filename=")[1];
      // iconv-lite解决中文乱码
      const iconv = require("iconv-lite");
      iconv.skipDecodeWarning = true; // 忽略警告
      const fileName = iconv.decode(tempName, "gbk");
      const blob = new Blob([data], { type: "application/vnd.ms-excel" }); // 转换成二进制对象
      if ("download" in document.createElement("a")) {
        // 不是IE浏览器
        const url = window.URL.createObjectURL(blob); // 二进制对象转换成url地址
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // 下载完成移除元素
        window.URL.revokeObjectURL(url); // 释放掉blob对象
      } else {
        window.navigator.msSaveBlob(blob, fileName);
      }
    }


    const getList = () => {
      loading.value = true;
      let params = {
        distributorId: searchParams.value.distributorId,
        currentPage: pageObj.value.page,
        size: pageObj.value.rows,
        orderCode: searchParams.value.orderCode,
        supplierId: searchParams.value.supplierId
      };

      if (searchParams.value.date.length) {
        params.startTime = searchParams.value.date[0];
        params.endTime = searchParams.value.date[1];
      }

      moneyApi.distributorMoney(params).then((res) => {
        console.log(res);
        loading.value = false;
        if (!res) return;
        pageObj.value.totle = res.total;
        pageObj.value.page = res.currentPage;

        list.value = res.data;
      });
      getBalanceById(params.distributorId);
    };
    let moneyTotle = ref({});

    let cardttitle = ref("");

    const getBalanceById = (id) => {
      if (id) {
        cardttitle.value = "";
      } else {
        cardttitle.value = "全部";
      }
      moneyApi
        .getBalanceById({
          distributorId: id,
        })
        .then((res) => {
          moneyTotle.value = res;
        });
    };

    const reset = () => {
      searchForm.value.distributorId = undefined;

      searchForm.value.date = [];
      searchAction();
    };

    let orderDetail = ref({});

    const toLook = (row) => {
      let params = {
        id: row.rechargeApplyId,
      };
      moneyApi.distributrMoneyDetail(params).then((res) => {
        modalVisible.value = true;
        orderDetail.value = res;
        orderDetail.value.flowCode = row.flowCode;
        orderDetail.value.distributorName = row.distributorBo.name;
      });
    };

    const toAdd = () => {
      router.push({
        name: "channelShopAddMoney",
      });
    };

    let viewVisible = ref(false);
    let prevImg = ref("");
    const preview = (info) => {
      viewVisible.value = true;
      prevImg.value = info;
    };

    const toShopDetail = (record) => {
      const newweb = router.resolve({
        name: "addChannelShopIndex",
        query: {
          id: record.distributorBo.id,
          type: "look",
        },
      });
      window.open(newweb.href, "_blank");
    };

    const toOrderDetail = (record) => {
      if (record.changeType == 30 || record.changeType == 31) {
        router.push({
          name: "orderDetail",
          query: {
            code: record.orderCode,
          },
        });
      } else {
        router.push({
          name: "refundDetailIndex",
          query: {
            code: record.returnOrderCode,
          },
        });
      }
    };

    provide("pageChange", pageChange);
    provide("onShowSizeChange", onShowSizeChange);

    getList();

    return {
      toOrderDetail,
      cardttitle,
      moneyTotle,
      toShopDetail,
      viewVisible,
      prevImg,
      preview,
      orderDetail,
      modalVisible,
      searchForm,
      searchParams,
      stateList,
      list,
      columns,
      pageObj,
      loading,
      searchAction,
      downloadAction,
      reset,
      toLook,
      toAdd,
      baseuri: process.env.VUE_APP_IMG_BASE,
    };
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.card_ct {
  display: flex;
  justify-content: flex-start;
  div {
    margin-right: 20px;
  }
}
.modal_ct {
  display: flex;
  justify-content: flex-start;
  & > div {
    width: 50%;
    & > .ar:first-child {
      border-top: 1px solid #00a0e9 !important;
    }
  }

  .bgl {
    background: rgba(0, 160, 233, 0.7);
    text-align: right;
    line-height: 40px;
  }
  .bgr {
    text-align: left;
    line-height: 40px;
    color: #000;
  }
  .ar {
    border: 1px solid #00a0e9;
    border-top: none;
    color: #fff;
  }
}

.modal_ct /deep/ .ant-row {
  margin: 0 !important;
}

.viewer_img {
  width: 100px;
  margin-right: 10px;
  border-radius: 3px;
  margin-bottom: 10px;
  cursor: pointer;
}
</style>

